import { PaymentSchedule } from "@redotech/redo-model/balance/balances";
import { createEnum } from "@redotech/zod/zod-enum";
import * as z from "zod/v4";
import { null as zNull } from "zod/v4";
export const getOutboundBalance = {
  name: "getOutboundBalance" as const,
  input: zNull(),
  output: z.object({
    balance: z.string(),
    paymentSchedule: createEnum(PaymentSchedule),
  }),
};
